import IAmount from "./IAmount";
import ISettingsConsolidation from "@/module/main/dto/ISettingsConsolidation";

export default class SettingsConsolidation implements ISettingsConsolidation {
    constructor(public installment?: IAmount, public productCode?: string) {}
}
